// extracted by mini-css-extract-plugin
export default {"root":"Legend_root__M7FV+"};